import { Shortcut, ShortcutType } from '@iese-chatbot/common-utils';
import { articleSystemMessage } from './shortcut-system-messages/article-system-message';
import { caseSystemMessage } from './shortcut-system-messages/case-system-message';
import { professorOrStaffSystemMessage } from './shortcut-system-messages/professor-or-staff-system-message';
import { programDirectorSystemMessage } from './shortcut-system-messages/program-director-system-message';
import { teachingNoteSystemMessage } from './shortcut-system-messages/teaching-note-system-message';
import { technicalNoteSystemMessage } from './shortcut-system-messages/technical-note-system-message';
import { translationSystemMessage } from './shortcut-system-messages/translation-system-message';

export const teachingNoteShortcut: Shortcut = {
  type: ShortcutType.TEACHING_NOTE,
  title: 'Create a teaching note',
  subtitle: 'Use',
  eventName: 'Teaching Note',
  systemMessage: teachingNoteSystemMessage.trim(),
  visible: true,
  allowsFiles: true,
};

export const caseShortcut: Shortcut = {
  type: ShortcutType.CASE,
  title: 'Create a new case',
  subtitle: 'Case',
  eventName: 'Case',
  systemMessage: caseSystemMessage.trim(),
  visible: true,
  allowsFiles: false,
};

export const technicalNoteShortcut: Shortcut = {
  type: ShortcutType.TECHNICAL_NOTE,
  title: 'Create a new technical note',
  subtitle: 'Technical Note',
  eventName: 'Technical Note',
  systemMessage: technicalNoteSystemMessage.trim(),
  visible: true,
  allowsFiles: false,
};

export const articleShortcut: Shortcut = {
  type: ShortcutType.ARTICLE,
  title: 'Create a new article',
  subtitle: 'Article',
  eventName: 'Article',
  systemMessage: articleSystemMessage.trim(),
  visible: true,
  allowsFiles: false,
};

export const syllabusShortcut: Shortcut = {
  type: ShortcutType.SYLLABUS,
  title: 'Create a syllabus proposal',
  subtitle: 'Use',
  eventName: 'Syllabus',
  systemMessage: programDirectorSystemMessage.trim(),
  visible: true,
  allowsFiles: false,
};

export const abstractKeywordsShortcut: Shortcut = {
  type: ShortcutType.ABSTRACT_KEYWORDS,
  title: 'Abstract creation and keyword extraction',
  subtitle: 'Use',
  eventName: 'Abstract',
  systemMessage: professorOrStaffSystemMessage.trim(),
  visible: true,
  allowsFiles: true,
};

export const translationsShortcut: Shortcut = {
  type: ShortcutType.TRANSLATIONS,
  title: 'Translate this content',
  subtitle: 'Use',
  eventName: 'Translations',
  systemMessage: translationSystemMessage.trim(),
  visible: true,
  allowsFiles: true,
};
